<form [formGroup]="formGroup!" class="register" data-testid="register-container">

  <app-modal-option-panel>
    <div class="modal-option-panel__stack">
      <div class="input-el">
        <input required name="email" placeholder="Email" formControlName="registerEmail" type="email" data-testid="register-email-input">
        @if (registerEmail.invalid && registerEmail.touched) {
          <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Email_Invalid }}</h6>
        }
        @if (existingEmailMsg) {
          <h6 class="invalid">{{ existingEmailMsg }}</h6>
        }
      </div>

      <div class="input-el">
        <div class="password-field">
          <input required name="new-password" autocomplete="new-password" class="password-input"
            data-testid="register-password-input"
            [placeholder]="languageService.languageJSON.Global_Password" formControlName="registerPassword"
            [type]="showPassword ? 'text' : 'password'">
          <button type="button" class="password-toggle"
            data-testid="register-password-toggle-btn"
            [ngClass]="showPassword ? 'password-eye-off' : 'password-eye-on'" (click)="togglePassword()"
            tabindex="-1" aria-label="Toggle password visibility"></button>
        </div>
        @if (registerPassword.invalid && registerPassword.touched) {
          <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Password_Invalid }}</h6>
        }
      </div>

      <div class="input-el">
        <div class="password-field">
          <input required name="new-password" autocomplete="new-password" class="password-input"
            data-testid="register-password-confirm-input"
            [placeholder]="languageService.languageJSON.Global_PasswordConfirmation"
            formControlName="registerPasswordConfirmation" [type]="showPasswordConfirmation ? 'text' : 'password'">
          <button type="button" class="password-toggle"
            data-testid="register-password-confirm-toggle-btn"
            [ngClass]="showPasswordConfirmation ? 'password-eye-off' : 'password-eye-on'"
            (click)="togglePasswordConfirmation()" tabindex="-1" aria-label="Toggle password visibility"></button>
        </div>
        <span class="error-container">
          @if (registerPasswordConfirmation.invalid && registerPasswordConfirmation.touched) {
            <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Password_Invalid }}</h6>
          }
          @if (registerPasswordsMatch) {
            <h6 class="invalid">{{ languageService.languageJSON.AccountDialog_Password_NotMatch }}</h6>
          }
        </span>
      </div>
    </div>
  </app-modal-option-panel>

  <app-modal-option-panel>
    <div class="modal-option-panel__stack">
      <div class="input-el social-row">
        <button type="button" class="account-btn google-btn social-icon-btn" (click)="accountService.signInWithGoogle()"
          data-testid="register-google-btn"
          [title]="languageService.languageJSON.AccountDialog_SignIn_Google">
          <img src="assets/icons/default/social/google_icon.svg" />
        </button>
        <button type="button" class="account-btn facebook-btn social-icon-btn"
          data-testid="register-facebook-btn"
          (click)="accountService.signInWithFacebook()"
          [title]="languageService.languageJSON.AccountDialog_SignIn_Facebook">
          <img src="assets/icons/default/social/facebook_icon.svg" />
        </button>
        @if (!preiOS13WebView && !androidWebView) {
          <button type="button" class="account-btn apple-btn social-icon-btn"
            data-testid="register-apple-btn"
            (click)="accountService.signInWithApple()"
            [title]="languageService.languageJSON.AccountDialog_SignIn_Apple">
            <img [src]="'assets/icons/' + settingsService.getMap().Skin + '/social/apple_logo.svg'" />
          </button>
        }
      </div>
    </div>
  </app-modal-option-panel>

  <app-modal-option-panel>
    <div class="input-el checkbox">
      <mat-checkbox formControlName="registerNewsletter" data-testid="register-newsletter-checkbox">
        {{ languageService.languageJSON.AccountDialog_SubscribeNewsletter }}
      </mat-checkbox>
    </div>
    <div class="input-el">
      <h5>{{ languageService.languageJSON.AccountDialog_PrivacyPolicyText }}
        <a (click)="openPrivacyPolicy.emit()" data-testid="register-privacy-policy-link">{{ languageService.languageJSON.AccountDialog_PrivacyPolicyLink }}</a>
        {{ languageService.languageJSON.Global_And.toLowerCase() }}
        <a (click)="openTermsOfUse.emit()" data-testid="register-terms-link">{{ languageService.languageJSON.AccountDialog_TermsofUseLink }}</a>
        {{ languageService.languageJSON.Global_And.toLowerCase() }}
        <a (click)="openEUDataActPolicy.emit()" data-testid="register-eu-data-act-link">{{ languageService.languageJSON.TabbedInfoDialog_EUDataActPolicy }}</a>
      </h5>
    </div>
  </app-modal-option-panel>
</form>
